export const exploreData = [
    {
        "type": "restaurant",
        "info": {
            "resId": 19522709,
            "name": "Rock N Roll",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/9/19522709/403a3bf665d424b068e3d0eb45ed125e_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/9/19522709/403a3bf665d424b068e3d0eb45ed125e_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.4",
                "rating_text": "3.4",
                "rating_subtitle": "Average",
                "rating_color": "CDD614",
                "votes": "3,557",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "2.7",
                        "reviewCount": "16",
                        "reviewTextSmall": "16 Reviews",
                        "subtext": "16 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "2.7",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "yellow",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.1",
                        "reviewCount": "3,541",
                        "reviewTextSmall": "3,541 Reviews",
                        "subtext": "3,541 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.1",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.8"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹200 for two"
            },
            "cfo": {
                "text": "₹100 for one"
            },
            "locality": {
                "name": "CIDCO, Aurangabad",
                "address": "Shop 15, Plot 10/B1, Ajanta Complex, CIDCO, Aurangabad",
                "localityUrl": "aurangabad/cidco-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/rolls/",
                    "name": "Rolls"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹100 for one"
            }
        },
        "order": {
            "deliveryTime": "19 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/rock-n-roll-cidco/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/rock-n-roll-cidco/order",
            "clickActionDeeplink": ""
        },
        "distance": "169 m",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19522709\",\"element_type\":\"listing\",\"rank\":1}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [
            {
                "text": "50% OFF",
                "color": {
                    "tint": "500",
                    "type": "blue"
                }
            }
        ],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 20924569,
            "name": "Bhakariwala",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/9/20924569/152df33520d8b7b89dbcfbb568101bc2_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/9/20924569/152df33520d8b7b89dbcfbb568101bc2_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.6",
                "rating_text": "3.6",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "526",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "",
                        "reviewCount": "2",
                        "reviewTextSmall": "2 Reviews",
                        "subtext": "Does not offer Dining",
                        "color": "",
                        "ratingV2": "-",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "grey",
                            "tint": "500"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "3.7",
                        "reviewCount": "524",
                        "reviewTextSmall": "524 Reviews",
                        "subtext": "524 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "3.7",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.6"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹300 for two"
            },
            "cfo": {
                "text": "₹150 for one"
            },
            "locality": {
                "name": "CIDCO, Aurangabad",
                "address": "Shop 3, Ground Floor, Cannought Garden, Town Center, CIDCO, Aurangabad",
                "localityUrl": "aurangabad/cidco-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                    "name": "Maharashtrian"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹150 for one"
            }
        },
        "order": {
            "deliveryTime": "28 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/bhakariwala-cidco/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/bhakariwala-cidco/order",
            "clickActionDeeplink": ""
        },
        "distance": "275 m",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20924569\",\"element_type\":\"listing\",\"rank\":2}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500123,
            "name": "Great Sagar Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/3/2500123/44182b34d99537916bb496305451b067_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/3/2500123/44182b34d99537916bb496305451b067_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.3",
                "rating_text": "4.3",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "20K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.2",
                        "reviewCount": "628",
                        "reviewTextSmall": "628 Reviews",
                        "subtext": "628 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.2",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.5",
                        "reviewCount": "19.4K",
                        "reviewTextSmall": "19.4K Reviews",
                        "subtext": "19.4K Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.5",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "800"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.5"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.3"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹600 for two"
            },
            "cfo": {
                "text": "₹250 for one"
            },
            "locality": {
                "name": "Nirala Bazar, Aurangabad",
                "address": "CTS 3003, VIP Road, Opposite Bhadkal Gate, Nirala Bazar, Aurangabad",
                "localityUrl": "aurangabad/nirala-bazar-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/mughlai/",
                    "name": "Mughlai"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sea-food/",
                    "name": "Seafood"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/kebab/",
                    "name": "Kebab"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                    "name": "Biryani"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                    "name": "Desserts"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/beverages/",
                    "name": "Beverages"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹250 for one"
            }
        },
        "order": {
            "deliveryTime": "31 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/great-sagar-restaurant-nirala-bazar/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/great-sagar-restaurant-nirala-bazar/order",
            "clickActionDeeplink": ""
        },
        "distance": "4.6 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500123\",\"element_type\":\"listing\",\"rank\":3}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500460,
            "name": "Hotel Rana",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/2500460/ad43959255a0aa0585d687419978c86d_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/0/2500460/ad43959255a0aa0585d687419978c86d_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "6,875",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.1",
                        "reviewCount": "132",
                        "reviewTextSmall": "132 Reviews",
                        "subtext": "132 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.1",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "3.9",
                        "reviewCount": "6,743",
                        "reviewTextSmall": "6,743 Reviews",
                        "subtext": "6,743 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "3.9",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.6"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹500 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "Usmanpura, Aurangabad",
                "address": "Opposite Fire Brigade, Railway Station Road, Usmanpura, Aurangabad",
                "localityUrl": "aurangabad/usmanpura-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                    "name": "Maharashtrian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTI4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sichuan/",
                    "name": "Sichuan"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹200 for one"
            }
        },
        "order": {
            "deliveryTime": "37 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/hotel-rana-usmanpura/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/hotel-rana-usmanpura/order",
            "clickActionDeeplink": ""
        },
        "distance": "4.9 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500460\",\"element_type\":\"listing\",\"rank\":4}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 18881994,
            "name": "Safa Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/4/18881994/eef4743922b644f7431f7349d0a8acca_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/4/18881994/eef4743922b644f7431f7349d0a8acca_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.9",
                "rating_text": "3.9",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "35.1K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.9",
                        "reviewCount": "449",
                        "reviewTextSmall": "449 Reviews",
                        "subtext": "449 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.9",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.0",
                        "reviewCount": "34.6K",
                        "reviewTextSmall": "34.6K Reviews",
                        "subtext": "34.6K Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.0",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "4.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.8"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹350 for two"
            },
            "cfo": {
                "text": "₹150 for one"
            },
            "locality": {
                "name": "Shahgunj, Aurangabad",
                "address": "1-19-52, Near Amber Dudh Dairy, Buddi Lane, Shahgunj, Aurangabad",
                "localityUrl": "aurangabad/shahgunj-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/mughlai/",
                    "name": "Mughlai"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                    "name": "Biryani"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTI4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sichuan/",
                    "name": "Sichuan"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹150 for one"
            }
        },
        "order": {
            "deliveryTime": "29 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/safa-restaurant-2-shahgunj/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/safa-restaurant-2-shahgunj/order",
            "clickActionDeeplink": ""
        },
        "distance": "4 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18881994\",\"element_type\":\"listing\",\"rank\":5}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [
            {
                "text": "₹200 OFF",
                "color": {
                    "tint": "500",
                    "type": "blue"
                }
            }
        ],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2500332,
            "name": "KFC",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/6/2500066/eeceb6b37200a6f510d9b1406f5ad220_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/6/2500066/eeceb6b37200a6f510d9b1406f5ad220_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.9",
                "rating_text": "3.9",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "10.5K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.1",
                        "reviewCount": "650",
                        "reviewTextSmall": "650 Reviews",
                        "subtext": "650 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.1",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "3.7",
                        "reviewCount": "9,836",
                        "reviewTextSmall": "9,836 Reviews",
                        "subtext": "9,836 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "3.7",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.5"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹500 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "Prozone Mall, Chicalthana, Aurangabad",
                "address": "Unit R-06, Plot P-80, First Floor, Prozone Mall, MIDC Industrial Area, Chikalthana, CIDCO, Aurangabad",
                "localityUrl": "aurangabad/restaurants/in/prozone-mall-chicalthana"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/burger/",
                    "name": "Burger"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/rolls/",
                    "name": "Rolls"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹200 for one"
            }
        },
        "order": {
            "deliveryTime": "40 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/kfc-cidco/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/kfc-cidco/order",
            "clickActionDeeplink": ""
        },
        "distance": "945 m",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2500332\",\"element_type\":\"listing\",\"rank\":6}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 18805876,
            "name": "Sai Panchavati Pav Bhaji And Pulav Center",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/6/18805876/e569e8cf45e0d971a75762a99e3c94dd_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/6/18805876/e569e8cf45e0d971a75762a99e3c94dd_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.0",
                "rating_text": "4.0",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "9,175",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.0",
                        "reviewCount": "178",
                        "reviewTextSmall": "178 Reviews",
                        "subtext": "178 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.0",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.0",
                        "reviewCount": "8,997",
                        "reviewTextSmall": "8,997 Reviews",
                        "subtext": "8,997 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.0",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹250 for two"
            },
            "cfo": {
                "text": "₹100 for one"
            },
            "locality": {
                "name": "Akashwani, Aurangabad",
                "address": "Trimurti Chowk, Jawahar Colony, Akashwani, Aurangabad",
                "localityUrl": "aurangabad/akashwani-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/street-food/",
                    "name": "Street Food"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹100 for one"
            }
        },
        "order": {
            "deliveryTime": "25 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/sai-panchavati-pav-bhaji-and-pulav-center-akashwani/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/sai-panchavati-pav-bhaji-and-pulav-center-akashwani/order",
            "clickActionDeeplink": ""
        },
        "distance": "1.9 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18805876\",\"element_type\":\"listing\",\"rank\":7}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 19169526,
            "name": "Sai Prasad Veg Restaurant",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/6/19169526/69edb4f9af5d19ddde597006477160b2_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/6/19169526/69edb4f9af5d19ddde597006477160b2_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.8",
                "rating_text": "3.8",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "2,267",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.9",
                        "reviewCount": "32",
                        "reviewTextSmall": "32 Reviews",
                        "subtext": "32 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.9",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "3.7",
                        "reviewCount": "2,235",
                        "reviewTextSmall": "2,235 Reviews",
                        "subtext": "2,235 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "3.7",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.5"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "500"
                                    },
                                    "rating": "3.4"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹300 for two"
            },
            "cfo": {
                "text": "₹150 for one"
            },
            "locality": {
                "name": "Usmanpura, Aurangabad",
                "address": "7, Cosmo Avenu, Near Baba Petrol Pump, Usmanpura, Aurangabad",
                "localityUrl": "aurangabad/usmanpura-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/maharashtrian/",
                    "name": "Maharashtrian"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹150 for one"
            }
        },
        "order": {
            "deliveryTime": "31 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/sai-prasad-veg-restaurant-usmanpura/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/sai-prasad-veg-restaurant-usmanpura/order",
            "clickActionDeeplink": ""
        },
        "distance": "5 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19169526\",\"element_type\":\"listing\",\"rank\":8}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [
            {
                "text": "10% OFF",
                "color": {
                    "tint": "500",
                    "type": "blue"
                }
            }
        ],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 18983870,
            "name": "Laxmi Sandwich & Pizza Centre",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/0/18983870/95870ce30f00d10893a6492cd2740194_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/0/18983870/95870ce30f00d10893a6492cd2740194_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.8",
                "rating_text": "3.8",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "10.5K",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.7",
                        "reviewCount": "37",
                        "reviewTextSmall": "37 Reviews",
                        "subtext": "37 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.7",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.0",
                        "reviewCount": "10.4K",
                        "reviewTextSmall": "10.4K Reviews",
                        "subtext": "10.4K Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.0",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.0"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.8"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹200 for two"
            },
            "cfo": {
                "text": "₹100 for one"
            },
            "locality": {
                "name": "Ulkanagari, Aurangabad",
                "address": "Shrikrishna Nagar, Jai Vishwa Bharti Colony, Ulkanagari, Aurangabad",
                "localityUrl": "aurangabad/ulkanagari-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/pizza/",
                    "name": "Pizza"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sandwich/",
                    "name": "Sandwich"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹100 for one"
            }
        },
        "order": {
            "deliveryTime": "45 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/laxmi-sandwich-pizza-centre-ulkanagari/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/laxmi-sandwich-pizza-centre-ulkanagari/order",
            "clickActionDeeplink": ""
        },
        "distance": "2.9 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18983870\",\"element_type\":\"listing\",\"rank\":9}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 19227456,
            "name": "Green Leaf - 2",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/6/19227456/8f676eb2bcfbaab904f3692068279765_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/6/19227456/8f676eb2bcfbaab904f3692068279765_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.9",
                "rating_text": "3.9",
                "rating_subtitle": "Good",
                "rating_color": "9ACD32",
                "votes": "7,691",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "3.7",
                        "reviewCount": "40",
                        "reviewTextSmall": "40 Reviews",
                        "subtext": "40 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "3.7",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "600"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.2",
                        "reviewCount": "7,651",
                        "reviewTextSmall": "7,651 Reviews",
                        "subtext": "7,651 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.2",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.0"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹500 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "Ulkanagari, Aurangabad",
                "address": "Plot 245, Shop 1 & 2, Garkheda Parisar, Ulkanagari, Aurangabad",
                "localityUrl": "aurangabad/ulkanagari-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/biryani/",
                    "name": "Biryani"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/desserts/",
                    "name": "Desserts"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹200 for one"
            }
        },
        "order": {
            "deliveryTime": "28 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/green-leaf-2-ulkanagari/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/green-leaf-2-ulkanagari/order",
            "clickActionDeeplink": ""
        },
        "distance": "2.6 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19227456\",\"element_type\":\"listing\",\"rank\":10}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 19751005,
            "name": "Mr. Rollwala",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/5/19751005/ff06d99b8a12749f5cdb0df9aa6980f5_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/5/19751005/ff06d99b8a12749f5cdb0df9aa6980f5_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "3.2",
                "rating_text": "3.2",
                "rating_subtitle": "Average",
                "rating_color": "CDD614",
                "votes": "2,295",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "2.2",
                        "reviewCount": "4",
                        "reviewTextSmall": "4 Reviews",
                        "subtext": "4 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "2.2",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "orange",
                            "tint": "300"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.2",
                        "reviewCount": "2,291",
                        "reviewTextSmall": "2,291 Reviews",
                        "subtext": "2,291 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.2",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.2"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.1"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹300 for two"
            },
            "cfo": {
                "text": "₹150 for one"
            },
            "locality": {
                "name": "Usmanpura, Aurangabad",
                "address": "Plot 5-1-43, Shop 1&2, Near Ram Mandir, Usmanpura, Aurangabad",
                "localityUrl": "aurangabad/usmanpura-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/fast-food/",
                    "name": "Fast Food"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/chinese/",
                    "name": "Chinese"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/burger/",
                    "name": "Burger"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/pizza/",
                    "name": "Pizza"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/sandwich/",
                    "name": "Sandwich"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹150 for one"
            }
        },
        "order": {
            "deliveryTime": "35 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/mr-rollwala-usmanpura/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/mr-rollwala-usmanpura/order",
            "clickActionDeeplink": ""
        },
        "distance": "4.1 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19751005\",\"element_type\":\"listing\",\"rank\":11}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    },
    {
        "type": "restaurant",
        "info": {
            "resId": 2501033,
            "name": "Koyla",
            "image": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/3/2501033/cda8f705ad2715d465e891b059fe0099_o2_featured_v2.jpg"
            },
            "o2FeaturedImage": {
                "url": "https://b.zmtcdn.com/data/pictures/chains/3/2501033/cda8f705ad2715d465e891b059fe0099_o2_featured_v2.jpg"
            },
            "rating": {
                "has_fake_reviews": 0,
                "aggregate_rating": "4.1",
                "rating_text": "4.1",
                "rating_subtitle": "Very Good",
                "rating_color": "5BA829",
                "votes": "5,582",
                "subtext": "REVIEWS",
                "is_new": false
            },
            "ratingNew": {
                "newlyOpenedObj": null,
                "suspiciousReviewObj": null,
                "ratings": {
                    "DINING": {
                        "rating_type": "DINING",
                        "rating": "4.0",
                        "reviewCount": "182",
                        "reviewTextSmall": "182 Reviews",
                        "subtext": "182 Dining Reviews",
                        "color": "#1C1C1C",
                        "ratingV2": "4.0",
                        "subtitle": "DINING",
                        "sideSubTitle": "Dining Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDining": false
                    },
                    "DELIVERY": {
                        "rating_type": "DELIVERY",
                        "rating": "4.3",
                        "reviewCount": "5,400",
                        "reviewTextSmall": "5,400 Reviews",
                        "subtext": "5,400 Delivery Reviews",
                        "color": "#E23744",
                        "ratingV2": "4.3",
                        "subtitle": "DELIVERY",
                        "sideSubTitle": "Delivery Ratings",
                        "bgColorV2": {
                            "type": "green",
                            "tint": "700"
                        },
                        "newOnDelivery": false,
                        "bucketRatings": {
                            "buckets": [
                                {
                                    "title": "Under 4 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "700"
                                    },
                                    "rating": "4.3"
                                },
                                {
                                    "title": "4 km to 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.9"
                                },
                                {
                                    "title": "Above 7 km",
                                    "bgColor": {
                                        "type": "green",
                                        "tint": "600"
                                    },
                                    "rating": "3.7"
                                }
                            ],
                            "tooltip": {
                                "title": "For orders under 4 km",
                                "bgColor": {
                                    "type": "green",
                                    "tint": "050"
                                },
                                "borderColor": {
                                    "type": "green",
                                    "tint": "300"
                                }
                            }
                        }
                    }
                }
            },
            "cft": {
                "text": "₹400 for two"
            },
            "cfo": {
                "text": "₹200 for one"
            },
            "locality": {
                "name": "Ulkanagari, Aurangabad",
                "address": "Shop 3, Plot 35/P, Shrinagar Housing Society, Opposite Gurukrupa Sweets, Ulkanagari, Aurangabad",
                "localityUrl": "aurangabad/ulkanagari-restaurants"
            },
            "timing": {
                "text": "",
                "color": ""
            },
            "cuisine": [
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                    "url": "https://www.zomato.com/aurangabad/restaurants/kebab/",
                    "name": "Kebab"
                },
                {
                    "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    "url": "https://www.zomato.com/aurangabad/restaurants/north-indian/",
                    "name": "North Indian"
                }
            ],
            "should_ban_ugc": false,
            "costText": {
                "text": "₹200 for one"
            }
        },
        "order": {
            "deliveryTime": "28 min",
            "isServiceable": true,
            "hasOnlineOrdering": true,
            "actionInfo": {
                "text": "Order Now",
                "clickUrl": "/aurangabad/koyla-ulkanagari/order"
            }
        },
        "gold": [],
        "takeaway": [],
        "cardAction": {
            "text": "",
            "clickUrl": "/aurangabad/koyla-ulkanagari/order",
            "clickActionDeeplink": ""
        },
        "distance": "2.5 km",
        "isPromoted": false,
        "promotedText": "",
        "trackingData": [
            {
                "table_name": "zsearch_events_log",
                "payload": "{\"search_id\":\"b5566c0c-bb52-428d-b731-533e5190209a\",\"location_type\":\"delivery_cell\",\"location_id\":\"4313219821455015936\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"2501033\",\"element_type\":\"listing\",\"rank\":12}",
                "event_names": {
                    "tap": "{\"action\":\"tap\"}",
                    "impression": "{\"action\":\"impression\"}"
                }
            }
        ],
        "allCTA": [],
        "promoOffer": "",
        "checkBulkOffers": true,
        "bulkOffers": [],
        "isDisabled": false,
        "bottomContainers": []
    }
]